import styled from 'styled-components';

export const RestaurantStyled = styled.div`
  width: 100%;
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  background-color: ${({ theme }) => theme.white};
  padding: 12px 24px;
  border-radius: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  min-height: 70px;
  gap: 16px;

  :hover {
    h5 {
      color: ${({ theme }) => theme.primary};
      transition: all 0.3s ease;
    }
  }

  @media (max-width: 800px) {
    margin-bottom: 8px;
    padding: 12px 20px;
  }
`;

export const BrandStyled = styled.div`
  width: 100%;
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  background-color: ${({ theme }) => theme.white};
  padding: 12px 24px;
  border-radius: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  gap: 16px;

  :hover {
    h5 {
      color: ${({ theme }) => theme.primary};
      transition: all 0.3s ease;
    }
  }

  @media (max-width: 800px) {
    padding: 8px 16px;
    margin-bottom: 8px;
  }
`;

export const CollapsibleBrands = styled.div<{
  expanded?: boolean;
  elementHeight?: number;
}>`
  opacity: ${(props) => (props.expanded ? '1' : '0')};
  visibility: ${(props) => (props.expanded ? 'visible' : 'hidden')};
  max-height: ${({ expanded, elementHeight }) =>
    expanded ? `${elementHeight}px` : '0px'};
  margin-top: ${(props) => (props.expanded ? '12px' : '0px')};
  margin-bottom: ${(props) => (props.expanded ? '32px' : '0px')};
  /* Collapsed, the box is 0px tall but its content still hangs out below it,
     invisible, and stretches the scroll area into a blank gap. So it clips
     while closed and while opening, and lets go once open (300ms), where the
     shadows and dropdowns inside must not be cut off. Without
     allow-discrete support it lets go at once, which only shows mid-open. */
  overflow: ${(props) => (props.expanded ? 'visible' : 'hidden')};
  transition: all 300ms,
    overflow 0s ${(props) => (props.expanded ? '300ms' : '0s')};
  transition-behavior: allow-discrete;

  @media (min-width: 3500px) {
    margin-top: ${(props) => (props.expanded ? '40px' : '0px')};
    margin-bottom: ${(props) => (props.expanded ? '80px' : '0px')};
  }

  @media (max-width: 800px) {
    margin-top: ${(props) => (props.expanded ? '10px' : '0px')};
    margin-bottom: ${(props) => (props.expanded ? '24px' : '0px')};
  }
`;

export const GridStats = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 40px;
  overflow-x: auto;
  padding: 10px 50px 40px 50px;
  margin: 0 -50px 0 -50px;

  > div {
    min-width: 22%;
  }

  @media (max-width: 800px) {
    display: flex;
    gap: 20px;
    overflow-x: auto;
    padding: 10px 30px 40px 30px;
    margin: 0 -30px 0 -30px;

    > div {
      min-width: 70vw;
    }
  }

  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const ProviderLogoWrapper = styled.div`
  width: 153px;
  height: 153px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 135px;
    height: 135px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.white};
    box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.1);
  }
`;
